import React from 'react';

import { matchPath, useLocation } from 'react-router';

import { appRoutes } from '@clearverify/constants';

export const useTestVerificationRequestsRoute = () => {
  const location = useLocation();

  const isTestRequestsRoute = React.useMemo(() => {
    return !!matchPath({ path: appRoutes.inbox.inboxTestRequests, end: false }, location.pathname);
  }, [location.pathname]);

  return { isTestRequestsRoute };
};
